<div class="hours-input">
  <div class="flex items-center gap-1 cursor-pointer mb-3" (click)="toggleExpand()">
    <div class="text-base font-bold text-gray-600">Business Hours</div>
    <mat-icon class="text-gray-600 transition-transform duration-200" [class.rotate-180]="isExpanded">expand_more</mat-icon>
  </div>
  <div class="flex flex-col gap-3" [class.hidden]="!isExpanded">
    <div *ngFor="let day of days; let i = index" class="flex items-center gap-4 border-b border-gray-200 pb-3 last:border-0 last:pb-0 mobile:flex-col mobile:items-start mobile:gap-2 mobile:pb-3">
      <!-- Day Label -->
      <div class="w-20 font-medium text-gray-700 mobile:w-auto mobile:min-w-full">
        {{ day.name }}
      </div>

      <!-- Checkbox -->
      <mat-checkbox 
        [formControl]="getDayFormGroup(i).get('enabled')"
        class="mr-2">
      </mat-checkbox>

        <!-- All-day toggle -->
        <mat-checkbox *ngIf="getDayFormGroup(i).get('enabled').value" [formControl]="getDayFormGroup(i).get('open24')">Open 24 hours</mat-checkbox>

        <!-- Time Dropdowns -->
        <div *ngIf="getDayFormGroup(i).get('enabled').value && !getDayFormGroup(i).get('open24').value" class="flex items-center gap-3 flex-1 custom-margin-bottom mobile:flex-col mobile:items-stretch mobile:gap-2">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Open Time</mat-label>
            <mat-select [formControl]="getDayFormGroup(i).get('openTime')" panelClass="mobile-hours-panel">
              <mat-option *ngFor="let time of timeValues" [value]="time.value">
                {{ time.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Close Time</mat-label>
            <mat-select [formControl]="getDayFormGroup(i).get('closeTime')" panelClass="mobile-hours-panel">
              <mat-optgroup label="Same day">
                <mat-option *ngFor="let time of getSameDayCloseTimes(i)" [value]="time.value">
                  {{ time.text }}
                </mat-option>
              </mat-optgroup>
              <mat-optgroup label="Next day">
                <mat-option *ngFor="let time of nextDayCloseValues" [value]="time.value">
                  {{ time.text }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        </div>

      <!-- Closed indicator -->
      <div *ngIf="!getDayFormGroup(i).get('enabled').value" class="text-gray-400 font-medium flex-1">
        Closed
      </div>
    </div>
  </div>
</div>

